import React from "react";

export const MobergMenuDivider = () => (
    <div style={{ height: "1px", background: "var(--color-border-default)", marginBlock: "4px" }} />
)